import { post, useFetch } from 'utils/sdk.ts';

interface InvoiceDetailsData {
  invoice_details: InvoiceDetails;
}

interface InvoiceDetails {
  first_name: string;
  last_name: string;
  phone: string;
  street: string;
  house_number: string;
  zipcode: string;
  city: string;
  country_code: string;
  email: string;
}

interface CountryList {
  code2: string;
  name: string;
}

export const sendVerificationEmail = (flightTicketRequestUuid: string, email: string) =>
  post(
    `api/customer-facing/flight-ticket-requests/${flightTicketRequestUuid}/invoice-details/send-verification-email`,
    {
      email: email,
    }
  );

export const useInvoiceDetails = (flightTicketRequestUuid: string, email: string) => {
  return useFetch<InvoiceDetailsData>(
    email == null
      ? null
      : `api/customer-facing/flight-ticket-requests/${flightTicketRequestUuid}/invoice-details?email=${encodeURIComponent(email)}`
  );
};

export const sendInvoiceDetails = (flightTicketRequestUuid: string, data: InvoiceDetails) =>
  post(`api/customer-facing/flight-ticket-requests/${flightTicketRequestUuid}/invoice-details/save`, data);

export const useVerifyEmail = (verificationUrl: string) => {
  return useFetch(`${verificationUrl}`);
};

export const useCountries = () => {
  return useFetch<CountryList[]>('api/customer-facing/customer-countries');
};
